export const MAX_INSTAGRAM_PROFILES = 10;
export const MAX_PROSPECT_COLORS = 5;
export const PROSPECT_PREVIEW_BG = '#17191F';
const DEFAULT_PROSPECT_COLORS = ['#003366', '#FF7043', '#F5F7FB'];

const isHexColor = (value) => /^#[0-9a-f]{6}$/i.test(String(value || '').trim());

const hexToRgb = (hex) => {
  const value = Number.parseInt(hex.replace('#', ''), 16);
  return { r: (value >> 16) & 255, g: (value >> 8) & 255, b: value & 255 };
};

const luminance = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  const linear = [r, g, b].map((channel) => {
    const value = channel / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * linear[0] + 0.7152 * linear[1] + 0.0722 * linear[2];
};

export const normalizeProspectColors = (colors) => {
  if (!Array.isArray(colors)) return [];
  return [...new Set(colors
    .map((color) => String(color || '').trim().toUpperCase())
    .filter(isHexColor))].slice(0, MAX_PROSPECT_COLORS);
};

export const buildProspectPalettePreview = (colors) => {
  const palette = normalizeProspectColors(colors);
  const usablePalette = palette.length ? palette : DEFAULT_PROSPECT_COLORS;
  const byLuminance = [...usablePalette].sort((first, second) => luminance(first) - luminance(second));
  const cardBg = byLuminance[0];
  const accent = byLuminance[byLuminance.length - 1];
  const coverEnd = byLuminance.length > 1
    ? byLuminance[byLuminance.length - 2]
    : accent;
  return {
    palette: usablePalette,
    pageBg: PROSPECT_PREVIEW_BG,
    cardBg,
    accent,
    cover: `linear-gradient(145deg, ${accent} 0%, ${coverEnd} 100%)`,
    text: luminance(cardBg) > 0.45 ? '#111827' : '#FFFFFF',
    accentText: luminance(accent) > 0.45 ? '#111827' : '#FFFFFF',
  };
};

const profileKey = (value) => {
  const trimmed = value.trim();
  if (/^(?:https?:\/\/)?(?:www\.|m\.)?instagram\.com\//i.test(trimmed)) {
    try {
      const url = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
      return (url.pathname.split('/').filter(Boolean)[0] || trimmed).toLowerCase();
    } catch {
      return trimmed.toLowerCase();
    }
  }
  return trimmed.replace(/^@+/, '').toLowerCase();
};

export const splitInstagramProfiles = (value) => {
  const seen = new Set();
  return String(value || '')
    .split(/[\s,;]+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .filter((item) => {
      const key = profileKey(item);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const formatInstagramMetric = (value) => {
  if (!Number.isFinite(value)) return 'Não disponível';
  return new Intl.NumberFormat('pt-BR', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value);
};

export const sourceLabel = (source) => {
  if (source === 'instagram') return 'Instagram';
  if (source === 'google') return 'Google';
  return null;
};
